import { render, staticRenderFns } from "./AllPayments.vue?vue&type=template&id=2dbd2a74&"
import script from "./AllPayments.vue?vue&type=script&lang=js&"
export * from "./AllPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports